// TC Account Ryoshusho Functions
// Adapted from live theme ryoshusho-generator.liquid

// Store order data when opening modal
var currentOrderAmount = '0';
var currentOrderDate = '';

// Open modal for a specific order
function openRyoshushoForOrder(amount, date) {
  currentOrderAmount = amount || '0';
  currentOrderDate = date || '';
  document.getElementById('ryoshushoModal').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeRyoshushoModal() {
  document.getElementById('ryoshushoModal').classList.remove('active');
  document.body.style.overflow = '';
  // Reset to form view
  document.getElementById('ryoshushoForm').classList.remove('hidden');
  document.getElementById('ryoshushoPreview').classList.remove('active');
}

function generateRyoshusho() {
  var recipient = document.getElementById('ryoshusho-recipient').value || '上様';
  var categorySelect = document.getElementById('ryoshusho-category');
  var category = categorySelect.value;
  
  if (category === 'その他') {
    var customCategory = document.getElementById('ryoshusho-custom-category').value;
    category = customCategory || 'その他';
  }
  
  // Use the stored order amount
  var formattedTotal = currentOrderAmount.replace(/[^\d]/g, '');
  formattedTotal = parseInt(formattedTotal || 0).toLocaleString('ja-JP');
  
  // Use order date or current date
  var dateStr = currentOrderDate;
  if (!dateStr) {
    var now = new Date();
    dateStr = now.getFullYear() + '年' + (now.getMonth() + 1) + '月' + now.getDate() + '日';
  }
  
  // Populate receipt
  document.getElementById('receiptRecipient').textContent = recipient;
  document.getElementById('receiptAmount').textContent = formattedTotal;
  document.getElementById('receiptCategory').textContent = category;
  document.getElementById('receiptDate').textContent = dateStr;
  
  // Show preview
  document.getElementById('ryoshushoForm').classList.add('hidden');
  document.getElementById('ryoshushoPreview').classList.add('active');
}

function backToForm() {
  document.getElementById('ryoshushoForm').classList.remove('hidden');
  document.getElementById('ryoshushoPreview').classList.remove('active');
}

function printRyoshusho() {
  // Open receipt in new window for clean printing
  var receipt = document.getElementById('ryoshushoReceipt');
  var receiptHTML = receipt.outerHTML;
  var hankoImg = document.getElementById('ryoshushoHanko');
  var hankoSrc = hankoImg ? hankoImg.src : '';
  
  var printWindow = window.open('', '_blank');
  printWindow.document.write(
    '<!DOCTYPE html>' +
    '<html>' +
    '<head>' +
    '<meta charset="UTF-8">' +
    '<title>領収書 - 印刷</title>' +
    '<style>' +
    '@page { size: A4 portrait; margin: 15mm; }' +
    '* { margin: 0; padding: 0; box-sizing: border-box; }' +
    'body { font-family: "Hiragino Kaku Gothic ProN", "Noto Sans JP", "Meiryo", sans-serif; background: #fff; padding: 20mm; }' +
    '.ryoshusho-receipt { background: #fff; max-width: 100%; margin: 0 auto; }' +
    '.ryoshusho-title { text-align: center; font-size: 28px; font-weight: bold; letter-spacing: 0.3em; margin-bottom: 50px; }' +
    '.ryoshusho-header-info { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 40px; padding-bottom: 30px; border-bottom: 2px solid #000; }' +
    '.ryoshusho-customer-info { text-align: left; }' +
    '.ryoshusho-recipient-name { font-size: 20px; font-weight: bold; border-bottom: 1px solid #000; display: inline-block; padding-right: 15px; margin-bottom: 8px; }' +
    '.ryoshusho-sama { font-size: 14px; margin-left: 8px; }' +
    '.ryoshusho-date { font-size: 13px; color: #333; margin-top: 10px; }' +
    '.ryoshusho-company-info { text-align: right; }' +
    '.ryoshusho-hanko-img { width: 220px; height: auto; }' +
    '.ryoshusho-body { display: flex; flex-direction: column; align-items: center; padding-top: 50px; }' +
    '.ryoshusho-amount-section { background: #f5f5f5; padding: 20px 60px; margin: 20px 0; border: 1px solid #ccc; text-align: center; width: 85%; }' +
    '.ryoshusho-amount-label { font-size: 12px; color: #666; margin-bottom: 5px; }' +
    '.ryoshusho-amount { font-size: 32px; font-weight: bold; }' +
    '.ryoshusho-tax-note { font-size: 11px; color: #666; margin-top: 5px; }' +
    '.ryoshusho-proviso { margin: 25px 0; font-size: 14px; text-align: center; }' +
    '.ryoshusho-proviso-label { color: #666; }' +
    '.ryoshusho-proviso-value { font-size: 16px; border-bottom: 1px solid #000; display: inline-block; padding: 0 20px; }' +
    '</style>' +
    '</head>' +
    '<body>' +
    receiptHTML +
    '<script>window.onload = function() { setTimeout(function() { window.print(); }, 500); };</scr' + 'ipt>' +
    '</body>' +
    '</html>'
  );
  printWindow.document.close();
}

function saveRyoshusho() {
  console.log('Save function called');
  var receipt = document.getElementById('ryoshushoReceipt');
  var saveBtn = document.querySelector('.ryoshusho-save-btn');
  
  // Show loading state
  if (saveBtn) {
    saveBtn.textContent = '処理中...';
    saveBtn.disabled = true;
  }
  
  // Load libraries dynamically if not loaded
  function loadScript(src) {
    return new Promise(function(resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  
  // Load html2canvas and jsPDF, then generate PDF
  Promise.all([
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'),
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js')
  ]).then(function() {
    // Wait a moment for libraries to initialize
    setTimeout(function() {
      html2canvas(receipt, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      }).then(function(canvas) {
        var jsPDF = window.jspdf.jsPDF;
        var pdf = new jsPDF('p', 'mm', 'a4');
        
        // A4 dimensions: 210 x 297 mm
        var pageWidth = 210;
        var margin = 15;
        var contentWidth = pageWidth - (margin * 2);
        
        // Calculate image dimensions to fit A4
        var imgWidth = contentWidth;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        
        // Add image to PDF
        var imgData = canvas.toDataURL('image/png');
        pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
        
        // Generate filename with date
        var now = new Date();
        var dateStr = now.getFullYear() + 
          String(now.getMonth() + 1).padStart(2, '0') + 
          String(now.getDate()).padStart(2, '0');
        var filename = 'TAISETSU COFFEE_領収書_' + dateStr + '.pdf';
        
        // Direct download
        pdf.save(filename);
        
        // Restore button
        if (saveBtn) {
          saveBtn.textContent = '💾 保存する';
          saveBtn.disabled = false;
        }
      }).catch(function(err) {
        console.error('PDF generation error:', err);
        alert('PDFの生成に失敗しました');
        if (saveBtn) {
          saveBtn.textContent = '💾 保存する';
          saveBtn.disabled = false;
        }
      });
    }, 100);
  }).catch(function(err) {
    console.error('Library load error:', err);
    alert('ライブラリの読み込みに失敗しました');
    if (saveBtn) {
      saveBtn.textContent = '💾 保存する';
      saveBtn.disabled = false;
    }
  });
}

// Initialize category select behavior
document.addEventListener('DOMContentLoaded', function() {
  var categorySelect = document.getElementById('ryoshusho-category');
  if (categorySelect) {
    categorySelect.addEventListener('change', function() {
      var customGroup = document.getElementById('customCategoryGroup');
      if (this.value === 'その他') {
        customGroup.style.display = 'block';
      } else {
        customGroup.style.display = 'none';
      }
    });
  }
});


// Order Detail Modal Functions
function openOrderDetail(orderId) {
  var dataEl = document.getElementById('order-data-' + orderId);
  if (!dataEl) {
    console.error('Order data not found for:', orderId);
    return;
  }
  
  try {
    var order = JSON.parse(dataEl.textContent);
    var modal = document.getElementById('orderDetailModal');
    var title = document.getElementById('orderDetailTitle');
    var body = document.getElementById('orderDetailBody');
    
    title.textContent = '注文 #' + order.number + 'TC';
    
    var html = '<p style="color:#666;margin-bottom:16px">' + order.date + '</p>';
    
    // Order items
    html += '<div class="tc-order-items">';
    order.items.forEach(function(item) {
      html += '<div class="tc-order-item">';
      if (item.image) {
        html += '<img src="' + item.image + '" alt="" class="tc-order-item-img">';
      }
      html += '<div class="tc-order-item-info">';
      html += '<div class="tc-order-item-title">' + escapeHtml(item.title) + '</div>';
      if (item.variant && item.variant !== 'Default Title') {
        html += '<div class="tc-order-item-variant">' + escapeHtml(item.variant) + '</div>';
      }
      html += '<div class="tc-order-item-qty">数量: ' + item.quantity + ' × ' + item.unit_price + '</div>';
      html += '</div>';
      html += '<div class="tc-order-item-price">' + item.price + '</div>';
      html += '</div>';
    });
    html += '</div>';
    
    // Order summary
    html += '<div class="tc-order-summary">';
    html += '<div class="tc-order-summary-row"><span>小計</span><span>' + order.subtotal + '</span></div>';
    if (order.shipping && order.shipping !== '¥0') {
      html += '<div class="tc-order-summary-row"><span>配送料</span><span>' + order.shipping + '</span></div>';
    }
    if (order.tax && order.tax !== '¥0') {
      html += '<div class="tc-order-summary-row"><span>税</span><span>' + order.tax + '</span></div>';
    }
    html += '<div class="tc-order-summary-row total"><span>合計</span><span>' + order.total + '</span></div>';
    html += '</div>';
    
    body.innerHTML = html;
    modal.classList.add('active');
    
  } catch (e) {
    console.error('Error parsing order data:', e);
  }
}

function closeOrderDetail() {
  var modal = document.getElementById('orderDetailModal');
  if (modal) {
    modal.classList.remove('active');
  }
}

function escapeHtml(text) {
  if (!text) return '';
  var div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Close modal on backdrop click
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('tc-order-detail-modal')) {
    closeOrderDetail();
  }
});

// Close modal on Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeOrderDetail();
    closeRyoshushoModal();
  }
});
